import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import DashboardContext from './context';
import SortableTableHeader from './common/sortable-table-header';
import WirePerformance from './published-wires-components/wire-performance';
import { SectionContainer, SectionTitle } from '../common/styles';

const SSectionContainer = styled(SectionContainer)`
  margin-top: 80px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  height: 16px;
  margin: 25px 0;

  & > * {
    text-align: right;
    ${props => props.theme.isLarge && `
      width: 80px;
    `};
    ${props => props.theme.isXLarge && `
      width: 100px;
    `};
  }

  & > *:first-child {
    flex-grow: 2;
    text-align: left;
  }

  & > *:nth-child(3) {
    ${props => props.theme.isLarge && `
      width: 110px;
    `};
    ${props => props.theme.isXLarge && `
      width: 130px;
    `};
  }
`;

const Button = styled.button`
  width: 210px;
  height: 36px;
  text-transform: uppercase;
  color: ${props => props.theme.primaryColor};
  background-color: ${props => props.theme.primaryColorTransparent};
  border: none;
  margin-top: 40px;
  font: ${props => props.theme.fontWeightHeavy} 14px/120% ${props => props.theme.fontFamilyBody};
`;

const WIRES_PAGE_SIZE = 5;

const counter = (result, item) => result + _.get(item, 'c', 0);
const mapper = wire => ({
  ...wire,
  views: _.get(wire, 'views', []).reduce(counter, 0),
  engagements: _.get(wire, 'engagements', []).reduce(counter, 0),
  likes: _.get(wire, 'likes', []).reduce(counter, 0),
  ctaClicks: _.get(wire, 'ctaClicks', []).reduce(counter, 0),
  enquiries: _.get(wire, 'enquiries', []).reduce(counter, 0),
});

export default function PublishedWires() {
  const { state: { wires } } = React.useContext(DashboardContext);
  const [visibleWires, setVisibleWires] = React.useState([]);
  const [auto, setAuto] = React.useState(false);
  const headerRef = React.useRef();

  React.useEffect(() => {
    // lodash's _.take can look after the case when there are not enough wires.
    setVisibleWires(_.take(wires, WIRES_PAGE_SIZE).map(mapper));
  }, [wires]);

  React.useEffect(() => {
    if (auto && headerRef.current) {
      headerRef.current.sort();
      setAuto(false);
    }
  }, [auto, wires]);

  const onLoadMore = () => {
    const n = Math.min(wires.length - visibleWires.length, WIRES_PAGE_SIZE);
    const moreWires = wires.slice(visibleWires.length, visibleWires.length + n).map(mapper);
    setVisibleWires(_.concat(visibleWires, moreWires));
    setAuto(true);
  };

  const columns = [
    { key: 'publishedDate', name: 'date' },
    { key: 'views' },
    { key: 'engagements' },
    { key: 'likes' },
    { key: 'ctaClicks', name: 'cta clicks' },
    { key: 'enquiries' },
  ];

  const headerProps = {
    array: visibleWires,
    setArray: setVisibleWires,
    columns,
    initialColumn: 'publishedDate',
  };

  return (
    <SSectionContainer>
      <SectionTitle>published wires</SectionTitle>
      <Header>
        <SortableTableHeader {...headerProps} ref={headerRef} />
      </Header>
      {visibleWires.map(wire => (
        <WirePerformance {...wire} key={wire.id} />
      ))}
      {visibleWires.length < wires.length && (
        <Button type="button" onClick={onLoadMore}>load more</Button>
      )}
    </SSectionContainer>
  );
}
